module.exports = __webpack_public_path__ + "img/internet.e2d7f5b0.svg";